import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const Navdata = () => {
  const history = useNavigate()
  //state data
  const [iscurrentState, setIscurrentState] = useState('Sales')

  const [filteredMenuItems, setFilteredMenuItems] = useState<any[]>([])

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute('sub-items')) {
      const ul: any = document.getElementById('two-column-menu')
      const iconItems = ul.querySelectorAll('.nav-icon.active')
      let activeIconItems = [...iconItems]
      activeIconItems.forEach((item) => {
        item.classList.remove('active')
        var id = item.getAttribute('sub-items')
        const getID = document.getElementById(id) as HTMLElement
        if (getID) getID.classList.remove('show')
      })
    }
  }

  useEffect(() => {
    document.body.classList.remove('twocolumn-panel')
  }, [history, iscurrentState])

  const menuItems: any = [
    {
      label: 'Menu',
      isHeader: true
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: 'mdi mdi-cash-register',
      link: '/sales',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Sales')
        updateIconSidebar(e)
      }
    },
    {
      id: 'booths',
      label: 'Booths',
      icon: 'mdi mdi-hubspot',
      link: '/booths',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Booths')
        updateIconSidebar(e)
      }
    },
    {
      id: 'locations',
      label: 'Locations',
      icon: 'mdi mdi-map-marker',
      link: '/locations',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Locations')
        updateIconSidebar(e)
      }
    },
    {
      id: 'services',
      label: 'Services',
      icon: 'mdi mdi-cog-outline',
      link: '/services',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Services')
        updateIconSidebar(e)
      }
    },
    {
      id: 'promotions',
      label: 'Promotions',
      icon: 'mdi mdi-ticket-percent',
      link: '/promotions',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Promotions')
        updateIconSidebar(e)
      }
    },
    {
      id: 'promotion-booths',
      label: 'Promotion Booths',
      icon: 'mdi mdi-file-table-box-multiple-outline',
      link: '/promotion-booths',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Promotion Booths')
        updateIconSidebar(e)
      }
    },
    {
      label: 'Asset Management',
      isHeader: true
    },
    {
      id: 'backgrounds',
      label: 'Backgrounds',
      icon: 'mdi mdi-image-multiple',
      link: '/backgrounds',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Backgrounds')
        updateIconSidebar(e)
      }
    },

    {
      id: 'accessories',
      label: 'Accessories',
      icon: 'mdi mdi-tshirt-crew',
      link: '/accessories',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Accessories')
        updateIconSidebar(e)
      }
    },
    {
      id: 'effects',
      label: 'Effects/Filters',
      icon: 'mdi mdi-auto-fix',
      link: '/effects',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Effects')
        updateIconSidebar(e)
      }
    },
    {
      label: 'Settings',
      isHeader: true
    },
    {
      id: 'timer-settings',
      label: 'Timer Settings',
      icon: 'mdi mdi-timer-cog-outline',
      link: '/timer-settings',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Timer Settings')
        updateIconSidebar(e)
      }
    },
    {
      id: 'translations',
      label: 'Translations',
      icon: 'mdi mdi-translate',
      link: '/translations',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Translations')
        updateIconSidebar(e)
      }
    },
    {
      label: 'Account',
      isHeader: true
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: 'mdi mdi-account-circle',
      link: '/profile',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Profile')
        updateIconSidebar(e)
      }
    },
    {
      id: 'users',
      label: 'Users',
      icon: 'mdi mdi-account-group',
      link: '/users',
      click: function (e: any) {
        e.preventDefault()
        setIscurrentState('Users')
        updateIconSidebar(e)
      }
    }
  ]

  useEffect(() => {
    const userType = sessionStorage.getItem('userType')
    const isAdmin = userType === '1'

    if (isAdmin) {
      // Admin/SuperAdmin sees everything
      setFilteredMenuItems(menuItems)
      return
    }

    // Operator: filter by pagePermissions
    let pagePermissions: any[] = []
    try {
      const stored = sessionStorage.getItem('userRoles')
      if (stored) pagePermissions = JSON.parse(atob(stored))
    } catch {}

    const allowedPages = new Set<string>()
    allowedPages.add('Profile') // Always show Profile
    if (Array.isArray(pagePermissions)) {
      pagePermissions.forEach((perm: any) => {
        if (perm?.canView && perm?.page) {
          allowedPages.add(perm.page)
        }
      })
    }

    const filtered = menuItems.filter((item: any) => {
      if (item.isHeader) {
        // Include header if at least one child after it is visible
        return true
      }
      return allowedPages.has(item.label)
    })

    // Remove orphan headers (headers with no items after them)
    const cleaned: any[] = []
    for (let i = 0; i < filtered.length; i++) {
      if (filtered[i].isHeader) {
        // Check if next non-header item exists
        const hasChild = filtered.slice(i + 1).some((f: any) => !f.isHeader)
        if (hasChild) cleaned.push(filtered[i])
      } else {
        cleaned.push(filtered[i])
      }
    }

    setFilteredMenuItems(cleaned)
  }, [])

  return <React.Fragment>{filteredMenuItems}</React.Fragment>
}
export default Navdata
